import React, { useState } from 'react';
import p from '@/assets/p.png';
import { Link } from '@mui/material';
import bell from '@/assets/notification.png';
const DiscussionTab = () => {
  return (
    <div className="descrt-component">
      <div className="row">
        <div className="col-12">
          <p className="f-20 text-black mb-3">Discussion</p>
          <p className="f-13 d-flex flex-wrap gap-1">
            <span className="text-black semi-bold">Tip:</span>
            <span style={{ width: '90%' }}>
              You can get email notifications about activity in discussions by clicking the bell
              icon to the right of the topic/title. To be able to participate in discussions, you
              must be authenticated with BankID
            </span>
          </p>
          <div className="discussion-card">
            <div className="discuss-head d-flex justify-between align-items-center">
              <h3 className='mb-0'>
                <span className="text-black f-16">New exciting deal</span>
                <span className="f-13">(Created 19.08.2024)</span>
              </h3>
              <span className="discuus-nt">
                <img src={bell} className="" />
              </span>
            </div>
            <div className="discuss-head d-flex justify-between align-items-center">
              <h3 className='d-flex gap-2 align-items-center'>
               <img src={p} className='discuuss-ico' />
                <span className="f-14">Pyke, Nikolai Philip ( Owner of the issue)</span>
              </h3>
              <span className="discuus-nt f-13">
              Last activity: a month ago
              </span>
            </div>
            <hr />
            <p className='f-14 px-3'>We update the database with new positive information. As read about in Finansavisen on 3 July, Hayk has entered into a partnership with the fleet management company GSGroup ( GSFleet.io ), where together we are testing an integrated solution against a major government agency.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscussionTab;
